<div *ngIf="tvAssociata">
  <hr class="divisore" class="divisore" />
  <div class="content__text">
    <h2 class="head">
      {{ "base.associata_title" | translate }}
    </h2>
    <div
      class="descrizione"
      [innerHTML]="'base.associata_description' | translate"
    ></div>
  </div>

  <div class="associata__flex mt-1">
    <img
      class="associata__img puntatore"
      [src]="tvAssociata.imgsrc"
      alt="Immagine copertina tipovisita {{ tvAssociata.titolo }}"
    />
    <div class="associata__content">
      <div class="associata__title puntatore under">
        {{ tvAssociata.titolo }}
      </div>
      <div class="associata__price">
        <div
          [ngClass]="
            tvAssociata.scontoAssociata > 0 ? 'underline' : 'not-underlined'
          "
          *ngIf="tvAssociata.scontoAssociata < 100"
        >
          <span class="valuta">€</span>
          <span class="base">
            {{ getCostoTipovisita(tvAssociata) | number : "1.2-2" }}
          </span>
        </div>
        <div
          *ngIf="tvAssociata.scontoAssociata > 0"
          class="not-underlined d-flex flex-column"
        >
          <div>
            <span class="scontato" *ngIf="tvAssociata.scontoAssociata < 100"
              >€</span
            >
            <span class="scontato" *ngIf="tvAssociata.scontoAssociata == 100">
              {{ "gite_extra.incluso" | translate | titlecase }}
            </span>
            <span class="scontato" *ngIf="tvAssociata.scontoAssociata < 100">
              {{
                getCostoTipovisitaScontato(
                  tvAssociata,
                  tvAssociata.scontoAssociata
                ) | number : "1.2-2"
              }}
            </span>
          </div>
        </div>
        <div
          class="valore-sconto"
          *ngIf="
            tvAssociata.scontoAssociata > 0 &&
            tvAssociata.scontoAssociata != 100
          "
        >
          <small>- {{ tvAssociata.scontoAssociata }}%</small>
        </div>
      </div>
      <div class="buttons__wrapper">
        <button
          class="button__add"
          (click)="setta()"
          [ngClass]="tvSelezionata ? 'attivo' : 'disattivo'"
        >
          <span *ngIf="!tvSelezionata">
            {{ "base.aggiungi_voucher" | translate }}
          </span>
          <span *ngIf="tvSelezionata">
            {{ "base.aggiunto_voucher" | translate }}
          </span>
        </button>
        <span
          class="material-symbols-outlined button__delete"
          (click)="resetta()"
          *ngIf="tvSelezionata"
        >
          delete
        </span>
      </div>
    </div>
  </div>
</div>
